import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "text-body1" }
const _hoisted_4 = { class: "text-info" }
const _hoisted_5 = { class: "text-overline text-disabled" }
const _hoisted_6 = { class: "text-overline" }

import { computed, PropType } from "vue"
import { useI18n } from "vue-i18n"
import SfxBtnLink from "src/components/button/SfxBtnLink.vue"
import { getTranslatedEntityForPage } from "src/util/functions/entity"
import { SystemLink } from "src/stores/filterStore"

//region Props and Emits

export default /*#__PURE__*/_defineComponent({
  __name: 'SfxFilterSystemLink',
  props: {
  systemLink: {
    type: Object as PropType<SystemLink>,
    required: true,
  },
},
  emits: ["remove"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit
//endregion

//region Variables
const { t } = useI18n()

const translatedEntity = computed(() =>
  props.systemLink?.entityType ? getTranslatedEntityForPage(props.systemLink?.entityType) : ""
)
//endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(_unref(t)("filter.label_system_link")) + " (", 1),
        _createElementVNode("b", _hoisted_4, _toDisplayString(translatedEntity.value), 1),
        _createTextVNode(") ")
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(props.systemLink.entityId), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(props.systemLink.entityDesignation), 1)
    ]),
    _createVNode(SfxBtnLink, {
      class: "q-pr-none",
      label: _unref(t)('sfxButtons.btn_remove'),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('remove')))
    }, null, 8, ["label"])
  ]))
}
}

})